"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DomainSchema = exports.getDomainTargetByIp = exports.DomainTarget = exports.DomainStatus = exports.CONST_CLOUFLARE_STATUS_READY = void 0;
const mongoose_1 = require("mongoose");
exports.CONST_CLOUFLARE_STATUS_READY = "active";
var DomainStatus;
(function (DomainStatus) {
    DomainStatus["PENDING"] = "pending";
    DomainStatus["READY"] = "ready";
    DomainStatus["READY_AND_NOTIFIED"] = "ready-and-notified";
    DomainStatus["WITHOUT_CLOUDFLARE"] = "without-cloudflare";
})(DomainStatus = exports.DomainStatus || (exports.DomainStatus = {}));
var DomainTarget;
(function (DomainTarget) {
    DomainTarget["KEITARO"] = "keitaro";
    DomainTarget["HOSTING"] = "hosting";
    DomainTarget["OTHER"] = "other";
    DomainTarget["MAIN"] = "main";
    DomainTarget["UNKNOWN"] = "unknown";
})(DomainTarget = exports.DomainTarget || (exports.DomainTarget = {}));
let getDomainTargetByIp = (ip) => {
    switch (ip) {
        case "194.61.120.94":
            return DomainTarget.MAIN;
        case "46.246.96.114":
            return DomainTarget.KEITARO;
        case "46.246.98.201":
            return DomainTarget.HOSTING;
        case "none":
            return DomainTarget.UNKNOWN;
        default: return DomainTarget.OTHER;
    }
};
exports.getDomainTargetByIp = getDomainTargetByIp;
exports.DomainSchema = new mongoose_1.Schema({
    id: String,
    namecheapId: String,
    name: String,
    caption: String,
    status: String,
    isUpdating: Boolean,
    cloudflareStatus: String,
    paused: Boolean,
    type: String,
    nameServers: [String],
    originalNameServers: [String],
    originalRegistrar: String,
    originalDNSHost: String,
    createdAt: Number,
    expiresAt: Number,
    ip: String,
    subdomain: String,
    txtRecords: [String],
    mxRecord: String,
    target: String,
    assignedTo: [Number],
    archived: Boolean,
    title: String,
    note: String,
    proxied: Boolean,
    appid: Number,
    expirationMessageSent: { type: Boolean, default: false }
});
